import { render, staticRenderFns } from "./ProductEditorInfo.vue?vue&type=template&id=5dc0ef6d&scoped=true&"
import script from "./ProductEditorInfo.vue?vue&type=script&lang=js&"
export * from "./ProductEditorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditorInfo.vue?vue&type=style&index=0&id=5dc0ef6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc0ef6d",
  null
  
)

export default component.exports